module.exports = __webpack_public_path__ + "img/appAsset-brand--defontana.c593ff3f.svg";